import React, { useEffect } from 'react'
import { $getSelection, $isRangeSelection, COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from 'lexical'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { SidebarTitle, SidebarType } from '../../../../Sidebar/models'
import { useAppDispatch } from '../../../../../../../../store/hooks'
import { displaySidebar } from '../../../../../../../../store/meetingSummary/display'
import { setResultExplainerResult } from '../../../../../../../../store/meetingSummary/meetingSupport'

export const EXPLAIN_RESULT_COMMAND: LexicalCommand<void> = createCommand('EXPLAIN_RESULT')

export interface ResultExplainerPluginProps {
  aiFeatureId: string
}

export const ResultExplainerPlugin: React.FC<ResultExplainerPluginProps> = ({ aiFeatureId }) => {
  const dispatch = useAppDispatch()

  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerCommand(
      EXPLAIN_RESULT_COMMAND,
      (_, editor) => {
        const selection = $getSelection()
        const domSelection = window.getSelection()
        if (domSelection !== null) {
          domSelection.removeAllRanges()
        }
        if ($isRangeSelection(selection)) {
          const selectedResult = editor.getEditorState().read(() => {
            return selection.getTextContent()
          })
          dispatch(setResultExplainerResult(selectedResult))
          dispatch(displaySidebar({ type: SidebarType.RESULT_EXPLAINER, title: SidebarTitle.RESULT_EXPLAINER, icon: 'bi-journal-text' }))
        }
        return true
      },
      COMMAND_PRIORITY_EDITOR,
    )
  }, [aiFeatureId, dispatch, editor])

  return null
}
